import {
  Component,
  OnInit,
  HostListener,
  OnDestroy,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  AfterContentChecked,
  AfterViewInit
} from '@angular/core';
import { CacheService } from '../services/cache.service';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '../services/common.service';
import { SSO } from './../../sso/sso.constants';
import flatten from 'lodash-es/flatten';
import { PortalCountry } from '../interfaces/portal-country.interface';
import { Country, CountryUrlMetaData } from '../interfaces/country.interface';
import { ConfigurationService } from '../services/configuration.service';
import { environment } from '../../../environments/environment';
import { DataShareService } from '../services/data.service';
import { CookieBannerType } from '../enums/cookie-banner-type';
import { AppMessageService } from '../../app-message.service';
import { CookieService } from 'ngx-cookie-service';
import { Cart } from '../models/cart.model';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MemberAllowedCountries } from '../interfaces/member-allowed-countries.interface';
import { CountryLanguage } from '../interfaces/country-language';
import { CookieBannerResponse } from '../interfaces/cookie-banner-response.interface';
import { MemberType } from '../enums/member-type.enum';
import { DisplayDirection } from '../constants/display-direction';
import { Translations } from '../constants/translations.constants';
import { HamburgerItemConstants } from '../constants';
import { Language } from '../interfaces/language.interface';
import { CountryMetaData } from '../interfaces/CountryMetaData.interface';

declare var canShowSplashInitally: any;
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'country-language-selector',
  templateUrl: '../templates/template1/views/new-country-language.component.html',
  styleUrls: [
    '../templates/template1/themes/default/less/new-country-language.component.less'
    // '../templates/template2/themes/default/less/country-language.component.less'
  ], animations: [
    trigger('slideInOut', [
      state('in', style({
        overflow: 'hidden',
        height: '*',
        opacity: '1'
      })),
      state('out', style({
        opacity: '0',
        overflow: 'hidden',
        height: '0px'
      })),
      transition('in <=> out', animate('400ms ease-in-out'))
    ])
  ]
})
export class CountryLanguageComponent implements OnInit, AfterContentChecked, AfterViewInit, OnDestroy {
  previousIndex: number;
  mouseClickIndex: number;
  showLanguages = false;
  selectedIndexCountry: number;
  selectedIndex = -1;
  mouseover = false;
  store: any;
  initalSettingValues: any;
  openSearch = false;
  isShowSearch = false;
  isModalShown = false;
  isCountryChanged = false;
  isShowCountryPopup = false;
  canCloseCountryDll = false;
  marginFlag = true;
  containerHeight = 0;
  isSubmitted = false;
  portalCountriesForUser: boolean;
  countryListHidden = false;
  canShowSplashScreen: boolean;
  countryLangSettings: any;
  countryInfo: any;
  languages: any = [];
  portalCountries: PortalCountry[];
  browserRegion: any;
  countries: any;
  selectedLanguage: any;
  defaultLanguage: any;
  isoCountryCode: string;
  selectedLanguageName: any;
  selectedCountry: Country;
  allCountries: any;
  browserCountry: Country;
  modalLanguage: any;
  image: any;
  previewConfig: Country;
  // tslint:disable-next-line:no-output-rename
  @Output('countryLanguageChange')
  countryLanguageChange: EventEmitter<any> = new EventEmitter<any>();
  countryLanguageCode = {
    countryCode: '',
    languageCode: ''
  };
  userInfo: any;
  memberAllowedCountries: any;
  searchCountry = '';
  isCountryPopupOpen = false;
  isLanguagePopupOpen = false;
  urlCountryCode: string;
  cookieService: CookieService = new CookieService(document);
  s3BucketUrl = environment.cdnURL;
  countryLanguages: CountryLanguage[] = [];
  portalImageUrl: any;
  isDistributor = false;
  scrollRetainPos = 0;
  elementHeight: number;
  coutrySplashHeight: number;

  parentCountry: Country;

  @Output("escapeClicked") public escapeClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @HostListener('document:click') closeLanguageDdl() {
    // close the language ddl when clicking apart from that ddl
    if (this.selectedIndexCountry >= 0) {
      this.selectedIndexCountry = -1;
    }
  }

  constructor(
    private _commonService: CommonService,
    private _translate: TranslateService,
    private _configurationService: ConfigurationService,
    private _cacheService: CacheService,
    private _dataService: DataShareService,
    private _appMessageService: AppMessageService,
    private cdRef: ChangeDetectorRef
  ) {
    this.isoCountryCode = this._cacheService.get(CacheKey.CountryName);
  }
  ngOnInit() {
    //  this.getSplashTopMargin();
    this.urlCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
    this.canShowSplashScreen = canShowSplashInitally;
    this._dataService.getSplashScreenFlag().subscribe(data => {
      this.canShowSplashScreen = data;
      if (this.canShowSplashScreen) {
        this.populateOldSelectedData();
        this.setBodyFixed(true);
      }
      this.countryListHidden = true;
    });
    this.getStoreData();
    this.getDefaultLanguage();
    this.getMemberAllowedCountries(this.urlCountryCode);
    this.countryLangSettings = this._cacheService.get(CacheKey.CountryLangSettings);
    this._appMessageService.getCookieBannerResponseData().subscribe((data) => {
      if (data) {
        if (data.saveSettings) {
          this.saveChangeSettings();
          if (!this.browserCountry.titanPlatformEnabled && !environment.betaPortal) {
            this.navigateToLegacy(this.browserCountry);
          }
        }
        this.canShowSplashScreen = data.canShowSplash;
      }
    });
  }

  ngAfterViewInit() {
    this.configureCountrySelectionContainer();
  }

  loadCurrentLocation(countryCodeFromURL: string) {
    this.allCountries = flatten(
      this.portalCountries.map(portal => portal.countries)
    );
    this.countryLangSettings = this._cacheService.get(CacheKey.CountryLangSettings);
    if (this.countryLangSettings && !this.urlCountryCode) {
      this.populateDdl();
    } else {
      let browserRegionIdFromCountry: number;
      this.isoCountryCode = countryCodeFromURL || this.isoCountryCode;
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.portalCountries.length; i++) {
        const region = this.portalCountries[i].countries
          .find((item) => item.isocodeThree.toLowerCase() === this.isoCountryCode.toLowerCase());
        if (region) {
          browserRegionIdFromCountry = this.portalCountries[i].regionId;
          break;
        }
      }
      this.browserCountry = this.allCountries.find((x: any) => (x.isocodeThree).toLowerCase() === this.isoCountryCode.toLowerCase());
      this.browserRegion = this.portalCountries.find(item => item.regionId
        === browserRegionIdFromCountry); // Need to update as per geo location
      this.portalImageUrl = this.getImageByRegion(this.browserRegion.regionName);
      this.countries = this.browserRegion ? this.portalCountries.filter(item => (item.regionId === this.browserRegion.regionId))
        .map(item => item.countries)[0] : null;
      const urlLanguageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
      if (urlLanguageCode) {
        this.modalLanguage = this.store.languages ? (this.store.languages.find((x: any) => x.cultureName ? x.cultureName.toLowerCase() === urlLanguageCode.toLowerCase() : x.languageCulture.toLowerCase() === urlLanguageCode.toLowerCase())) :
          (this.store.countryLanguages.find((x: any) => x.cultureName ? x.cultureName.toLowerCase() === urlLanguageCode.toLowerCase() : x.languageCulture.toLowerCase() === urlLanguageCode.toLowerCase()));
      } else {
        this.modalLanguage = this.store.languages ? (this.store.languages.find((x: any) => x.default === true) ?
          this.store.languages.find((x: any) => x.default === true) : this.store.languages[0]) :
          (this.store.countryLanguages.find((x: any) => x.default === true) ?
            this.store.countryLanguages.find((x: any) => x.default === true) : this.store.countryLanguages[0]);
      }
    }
    this.selectedCountry = this.browserCountry;
    this.selectedLanguageName = this.modalLanguage.displayText;
    this.countryLangSettings = this._cacheService.get(CacheKey.CountryLangSettings);
    const selectedCountLang = {
      countryCode: this.isoCountryCode, languageCode: this.selectedLanguage,
      selectedCountry: this.selectedCountry,
      selectedLanguageName: this.selectedLanguageName
    };
    this.configureCountrySelectionContainer();
    this.countryLanguageChange.emit(selectedCountLang);
    this.selectedCountry = this.browserCountry;
    if (countryCodeFromURL && !this.canShowSplashScreen) {
      this.countryLangSettings = {
        regionId: this.browserRegion.regionId,
        countryId: this.browserCountry.countryId,
        langId: this.modalLanguage.languageId
      };
      this._cacheService.set(CacheKey.CountryLangSettings, this.countryLangSettings);
    }
    this.initalSettingValues = { country: this.browserCountry, language: this.modalLanguage, region: this.browserRegion };
  }

  /**
   * IN COUNTRY MODAL POPUP
   * While changing the Country
   * It will populate the corresponding Languages
   * @param  {any} event
   */
  modalCountryChange(index: number, country: Country) {
    let countryCode: string;
    // sessionStorage.removeItem('menus');
    if (this.browserCountry) {
      countryCode = this.browserCountry.isocodeThree;
      this._configurationService.getStoreByCountry(countryCode).subscribe(response => {
        if (response) {
          response.requestCountryCode = countryCode;
          this.store = response;
          if (this.store.languages != null && this.store.languages.length > 0) {
            //  this.cookieService.set(CacheKey.countryCode, this.store.countryCode);
            this.countryLanguages = this.store.languages;
            this.modalLanguage = this.store.languages.find((x: any) => x.default === true);
            if (!this.initalSettingValues.language) {
              this.initalSettingValues.language = this.modalLanguage;
            }
          }
          this.selectedIndexCountry = index;
          this.setDropPosition(index);
          this.selectFirstLanguage();
        }
      }, (error) => {
        if (country && country.countryId) {
          this._configurationService.getCountryByCountryId(country.countryId).subscribe((response: Country) => {
            if (response && response.countryLanguages) {
              this.previewConfig = response;
              this.countryLanguages = response.countryLanguages || [];
              this.modalLanguage = response.countryLanguages.find((x: any) => x.default === true);
               if (!this.initalSettingValues.language) {
              this.initalSettingValues.language = this.modalLanguage;
                }
              this._commonService.getmappedcountries(country.isocodeThree).subscribe((response: CountryMetaData) => {
                if (response && response.countryID) {
                  const metaData: CountryMetaData = response;
                  this._cacheService.set(CacheKey.CountryMetaData, JSON.stringify(metaData));
                }
              });
            }
            this.selectedIndexCountry = index;
            this.setDropPosition(index);
          }, (error) => {
            this.selectedIndexCountry = index;
            this.setDropPosition(index);
          });
        }
      });
    }
  }


  /**
   * set th dropdown position
   * @param  {number} index
   * @returns void
   */
  setDropPosition(index: number): void {
    setTimeout(() => {
      const ele = document.querySelector('.full-visible #country' + index + ' .language-dropmenu');
      if (ele) {
        const menuPosition = ele.getBoundingClientRect().bottom;
        const viewportHeight = window.innerHeight;
        if (menuPosition > (viewportHeight - 30)) {
          ele.classList.add('dropup');
        } else {
          ele.classList.add('down');
        }
      }
    }, 0);
  }

  /**
  * IN COUNTRY MODAL POPUP
  * While changing the Language
  * stores the Language
  * @param  {any} event
  */
  modalLanguageChange(event: any) {
    this._cacheService.setCookieValue(CacheKey.languageCode, this.modalLanguage.cultureName);
  }


  /*
  * to get member allowed countries info
 */
  getMemberAllowedCountries(countryCodeFromURL?: string): void {
    this.userInfo = this._cacheService.get(CacheKey.UserInfo);
    if (this.userInfo && this.userInfo.memberId) {
      this._commonService.getMemberAllowedCountries(this.userInfo.memberId).subscribe(res => {
        if (res && res.length > 0) {
          this.memberAllowedCountries = res;
        }
        this.getPortalCountries(countryCodeFromURL);
      });
    } else {
      this.getPortalCountries(countryCodeFromURL);
    }
  }

  /**
   * to get portal countries on init
   */
  getPortalCountries(countryCodeFromURL?: string): void {
    this.userInfo = this._cacheService.get(CacheKey.UserInfo);
    this._commonService.getPortalCountries().subscribe((portalCountries: PortalCountry[]) => {
      this.portalCountries = portalCountries;
      this._cacheService.set(CacheKey.PortalCountries, portalCountries);
      if (this.memberAllowedCountries && this.memberAllowedCountries.length > 0) {
        this.portalCountries.forEach((portal: PortalCountry) => {
          portal.countries = portal.countries.filter(x =>
            this.memberAllowedCountries.some(y => y.isoCodeThree === x.isocodeThree && y.authorized));
        });
        this.portalCountries = this.portalCountries.filter((item: PortalCountry) => item.countries && item.countries.length > 0);
      }
      this.portalCountries.forEach((portal: PortalCountry) => {
        if (portal.regionName) {
          portal.imageUrl = this.getImageByRegion(portal.regionName);
        }
      });
      this.portalCountries.forEach((portal: PortalCountry) => {
        portal.countries.forEach((country: any) => {
          this.loadCurrentLocation(countryCodeFromURL);
          if ((countryCodeFromURL && countryCodeFromURL.toLocaleLowerCase() === country.isocodeThree.toLocaleLowerCase())
            || (this.isoCountryCode && (country.isocodeThree.toLocaleLowerCase() === this.isoCountryCode.toLocaleLowerCase()))
            || (this.userInfo && this.userInfo.homeCountryId &&
              (country.isocodeThree.toLocaleLowerCase() === String(this.userInfo.homeCountryId).toLocaleLowerCase()))) {
            this.selectedCountry = country;
            this.loadCurrentLocation(countryCodeFromURL);
            return;
          }
        });
      });
    });
    this.portalCountriesForUser = true;
  }
  /**
   * get default language of store
   * @returns void
   */
  getDefaultLanguage(): void {
    this.languages = this.store.languages || this.store.countryLanguages;
    if (this.languages && this.languages.length > 0) {
      const storeDefault: any = this.languages.find((x: any) => x.default === true) || this.languages[0];
      const defaultLang: any = this.languages.find((x: any) =>
        x.languageCultureId === storeDefault.languageCultureId);
      this.defaultLanguage = defaultLang.cultureName || defaultLang.languageCulture;
      this._cacheService.set(CacheKey.DefaultLanguage, this.defaultLanguage);
    }
    this.selectedLanguage = this._cacheService.getCookieValue(CacheKey.languageCode);
    if (!this.selectedLanguage || (this.selectedLanguage
      && (!this.checkSelectedLanguageisDefault(this.languages,this.selectedLanguage)))) {
      this.selectedLanguage = this.defaultLanguage;
      this._cacheService.setCookieValue(CacheKey.languageCode, this.selectedLanguage);
    }
    this.selectedLanguageName = this.languages.find((x: any) =>
      x.cultureName ? x.cultureName.toLowerCase() === this.selectedLanguage.toLowerCase() : x.languageCulture.toLowerCase() === this.selectedLanguage.toLowerCase()).displayText
      || this.languages.find((x: any) => x.cultureName ? x.cultureName.toLowerCase() === this.selectedLanguage.toLowerCase() : x.languageCulture.toLowerCase() === this.selectedLanguage.toLowerCase()).languageName
      || this.languages.find((x: any) => x.cultureName ? x.cultureName.toLowerCase() === this.selectedLanguage.toLowerCase() : x.languageCulture.toLowerCase() === this.selectedLanguage.toLowerCase()).languageName;
    this.countryLanguageCode.countryCode = this.isoCountryCode;
    this.countryLanguageCode.languageCode = this.selectedLanguage;
    this.translate();
  }

  checkSelectedLanguageisDefault(languages: any = [], selectedlanguage: any): Boolean {
    let result: Boolean = false;
    languages.find(x => {
      if (x.cultureName) {
        if (x.cultureName.toLowerCase() === selectedlanguage.toLowerCase()) {
          result = true;
        }
      }
      else if (x.languageCulture) {
        if (x.languageCulture.toLowerCase() === selectedlanguage.toLowerCase()) {
          result = true;
        }
      }
    });
    return result;
  }

  /*getselectedlanguageName(languages : any =[], selectedlanguage : any) : String{
    let languageName : String;
    languageName=languages.find(x =>{
    if(x.cultureName){
     x.cultureName.toLowerCase() === this.selectedLanguage.toLowerCase().displayText
      || this.languages.find((x: any) => x.cultureName.toLowerCase() === this.selectedLanguage.toLowerCase()).languageName
      || this.languages.find((x: any) => x.languageCulture.toLowerCase() === this.selectedLanguage.toLowerCase()).languageName;
     }
   });
 

  }*/
  /**
   * To translate the text
   * @returns void
   */
  translate(): void {
    this.selectedLanguage = this._cacheService.getCookieValue(CacheKey.languageCode);
    this.defaultLanguage = this._cacheService.get(CacheKey.DefaultLanguage);
    if (this.selectedLanguage != null && this.selectedLanguage !== undefined) {
      this._translate.use(this.selectedLanguage);
    } else if (
      this.defaultLanguage != null &&
      this.defaultLanguage !== undefined
    ) {
      this._translate.use(this.defaultLanguage);
    }
  }


  navigateToLegacy(country: Country) {
    if (country) {
      let language;
      if (this.modalLanguage) {
        language = this.modalLanguage.languageCulture ? this.modalLanguage.languageCulture.split('-')[0] : 'en';
      }
      let url = '';
      // If User Logged in, SSO Integration with Legacy
      if (this.userInfo) {
        url = environment.authenticatedLegacyRedirectUrl + '/' + country.isocodeThree.toLowerCase() + '/' + language;
      } else {
        // If User is not Logged in, redirectly to Legacy Corporate Site
        url = environment.unauthenticatedLegacyRedirectUrl + '/' + country.isocodeThree.toLowerCase() + '/' + language;
      }
      url = this._commonService.appendFBOID(url, true);
      window.open(url, '_blank');
    }
  }

  /**
   * Get Country Specific Languages from Configuration Service
   */
  getLanguagesForNonTitanEnabledCountry(index: number, country: Country, isRedirectToParent?: boolean, language?: Language) {
    this.browserCountry = country;
    this.canCloseCountryDll = false;
    this.modalLanguage = null;
    this.isCountryChanged = true;
    this.showLanguages = isRedirectToParent ? false : true;
    if (country && country.countryId) {
      this._configurationService.getCountryByCountryId(country.countryId).subscribe((response: Country) => {
        if (response && response.countryLanguages) {
          this.previewConfig = response;
          this.countryLanguages = response.countryLanguages || [];
          this.modalLanguage = response.countryLanguages.find((x: any) => x.default === true);
          if (isRedirectToParent) {
            this.navigateToParentCountry(response, language);
          } else {
            this.selectedIndexCountry = index;
            this.setDropPosition(index);
          }
        } else {
          this.navigateToLegacy(country);
        }
      });
    }
  }

  /**
   * Navigate to parent country
   * @param response
   * @param language
   */
  navigateToParentCountry(response: Country, language: Language): void {
    const filterdLanguage = response.countryLanguages.find(item => item.languageCulture.toLowerCase()
      === language.languageCulture.toLocaleLowerCase());
    this._cacheService.set(CacheKey.PreviewConfig, this.previewConfig);
    const parentCountryLanguage = filterdLanguage ? language : this.modalLanguage;
    this._cacheService.setCookieValue(CacheKey.languageCode, parentCountryLanguage.languageCulture);
    this.setLanguageDirectionCookie(parentCountryLanguage.displayDirection);
    this._cacheService.remove(CacheKey.SiteMaps);
    this._cacheService.setCookieValue(CacheKey.countryCode, this.browserCountry.isocodeThree.toLowerCase());
    window.location.href = decodeURIComponent(encodeURIComponent(environment.baseHref
      + this.browserCountry.isocodeThree.toLowerCase() + '/' + parentCountryLanguage.languageCulture.toLowerCase() + '/home'));
  }


  /**
   * Stores the language and country in localStorage
   * and Navigates to particular Country
   */
  setCountryAndLanguage() {
    sessionStorage.setItem('showPopup', JSON.stringify(false));
    this.isShowCountryPopup = false;
    if ((this.isoCountryCode.toLowerCase() !== this.browserCountry.isocodeThree.toLowerCase())
      || (this.modalLanguage.cultureName &&
        this.selectedLanguage.toLowerCase() !== this.modalLanguage.cultureName.toLowerCase())) {
      this.isoCountryCode = (this.browserCountry.isocodeThree).toLowerCase();
      this._cacheService.setCookieValue(CacheKey.languageCode, this.modalLanguage.cultureName);
      this._cacheService.setCookieValue(CacheKey.countryCode, this.isoCountryCode);
      //   this._localStorageService.set(CacheKey.CountryName, this.isoCountryCode);
      if (this.browserCountry) {
        this.getConfigurations(this.isoCountryCode);
      }
    }
  }

  // get image url
  getImageByRegion(regionCode: string) {
    let imageUrl;
    switch (regionCode) {
      case 'Africa':
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-africa_Shadow.png';
        break;
      case 'North America':
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-north-america_Shadow.png';
        break;
      case 'Latin America':
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-latin-america.png';
        break;
      case 'Southern and Central Asia':
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-asia_Shadow.png';
        break;
      case 'Asia':
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-asia_Shadow.png';
        break;
      case 'Europe':
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-europe_Shadow.png';
        break;
      case 'Middle East':
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-middle-east_Shadow.png';
        break;
      case 'Caribbean':
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-caribbean_Shadow.png';
        break;

      case 'Pacific Rim':
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-pacific-rim_Shadow.png';
        break;

      default:
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-americas_Shadow.png';
        break;
    }
    return imageUrl;
  }

  onRegionSelect(browserRegion: any) {
    if (browserRegion && browserRegion.regionId) {
      this.onRegionChange(browserRegion.regionId);
    }
  }
  /**
    * region change in splash screen
    * @param  {any} browserReg
    * @returns void
    */
  onRegionChange(browserRegID: number, index: number = -1) {
    if (browserRegID === this.browserRegion.regionId && window.innerWidth < 768) {
      this.browserRegion = null;
      return;
    }

    this.browserRegion = this.portalCountries.find((item: any) => item.regionId === browserRegID);
    this._appMessageService.setReigonIdSelect(browserRegID);
    if (this.browserRegion && this.browserRegion.imageUrl) {
      this.portalImageUrl = this.browserRegion.imageUrl;
    }
    this.countries = this.browserRegion ? this.portalCountries.filter(item => (item.regionId === this.browserRegion.regionId))
      .map(item => item.countries)[0] : null;
    this.configureCountrySelectionContainer();
    this.browserCountry = null;
    this.modalLanguage = null;
    this.showLanguages = false;
    this.selectedIndexCountry = -1;
    this.mouseover = true;
    // this.selectedIndex=index;
    this.mouseClickIndex = index;
    this.previousIndex = this.mouseClickIndex;
  }
  @HostListener('window:resize', ['$event'])
  onResize($event: Event): void {
    this.configureCountrySelectionContainer();
    this.cdRef.detectChanges();
  }


  /**
   * Configure Country Selection Container Height
   * configureCountryDiplay
   * @returns {void}
   * @memberof CountryLanguageComponent
   */
  configureCountrySelectionContainer(): void {
    const screenWidth = window.innerWidth;
    let addAdditionalHeight = false;
    if (this.countries && this.countries.length < 5 || (!this.countries)) {
      if (screenWidth && screenWidth >= 768) {
        this.elementHeight = 100;
      } else {
        this.elementHeight = 200;
      }
      return;
    }
    let noOfColumn;
    if (screenWidth && screenWidth >= 1200) {
      noOfColumn = 4;
    } else if (screenWidth && screenWidth >= 992) {
      addAdditionalHeight = true;
      noOfColumn = 3;
    } else if (screenWidth && screenWidth >= 768) {
      addAdditionalHeight = true;
      noOfColumn = 2;
    } else {
      noOfColumn = 1;
    }
    this.elementHeight = 43;
    const noOfRowsM = this.countries.length % noOfColumn;
    const noOfRowsD = this.countries.length / noOfColumn;
    if (noOfRowsM > 0) {
      this.elementHeight = this.elementHeight * (Number(noOfRowsD) + 1);
    } else {
      this.elementHeight = this.elementHeight * (Number(noOfRowsD));
    }
    if (this.isRTL() && addAdditionalHeight) {
      this.addAdditionalHightForRTL(50);
    }
    this.selectFirstCountry();
  }

  isRTL() {
    let displayDirection = this._cacheService.getCookieValue(CacheKey.LanguageDisplayDirection);
    if (displayDirection.toLowerCase() == DisplayDirection.RTL.toLowerCase()) {
      return true;
    }
    return false;
  }

  addAdditionalHightForRTL(height: number) {
    this.elementHeight = this.elementHeight + height;
  }



  /**
  * country change in splash screen
  * @param  {any} country
  * @returns void
  */
  onCountryChange(country: Country, index: number, event: any) {
    // Navigate to Legacy Site if Country is not titanPlatformEnabled and if user is Logged in
    if (!country.titanPlatformEnabled) {
      if (this.selectedIndexCountry >= 0 && this.selectedIndexCountry === index) {
        event.preventDefault();
        return;
      }
      this.validateParentCountryCodeByCountry(country);
      this.getLanguagesForNonTitanEnabledCountry(index, country);
      this.selectFirstLanguage();
    } else {
      this.parentCountry = null;
      // if already country drop down opened and same country ddl opened prevent the default event.
      if (this.selectedIndexCountry >= 0 && this.selectedIndexCountry === index) {
        event.preventDefault();
        return;
      }
      if (!country.associatedCountryCodeThree) {
        this.browserCountry = country;
      } else if (country.associatedCountryCodeThree) {
        this.browserCountry = this.getHomeCountryByParticipatingCountry(country);
      }
      this.modalCountryChange(index, country);
      this.canCloseCountryDll = false;
      this.modalLanguage = null;
      this.isCountryChanged = true;
      this.showLanguages = true;
      this.selectFirstLanguage();
    }
  }
  /**
   * Regarding NMC-646, When selected country url meta data
   * having redirectParent country code, we need to redirect with parent country code
   * @param country
   */
  validateParentCountryCodeByCountry(country: Country): Country {
    let urlMetaData: CountryUrlMetaData;
    let parentCountry: Country;
    if (environment.allCountriesCorporateEnabled && country.urlMetadata
      && country.urlMetadata && country.urlMetadata.length) {
      urlMetaData = country.urlMetadata.find(item =>
        item.portal === HamburgerItemConstants.CORPORATE);
    }
    if (urlMetaData && urlMetaData.redirectToParentCountry
      && country.associatedCountryCodeThree) {
      const portalCountries = this._cacheService.get(CacheKey.PortalCountries) || [];
      portalCountries.forEach(region => {
        region.countries.forEach((item: Country) => {
          if (item.isocodeThree.toLowerCase() === country.associatedCountryCodeThree.toLowerCase()) {
            parentCountry = item;
          }
        });
      });
    }
    return parentCountry;
  }

  setIndex(index: number, isMouseOver: boolean) {
    this.selectedIndex = index;
    this.mouseover = isMouseOver;
    if (isMouseOver) {
      this.mouseClickIndex = index;
    } else {
      this.mouseClickIndex = this.previousIndex;
    }
  }

  onSelectedLanguage(language: any) {
    this.modalLanguage = language;
  }
  outsideClickCloseSplashScreen(isOpen: boolean): void {
    if (this.canShowSplashScreen) {
      this.canShowSplashScreen = isOpen;
      this.setBodyFixed(false, true);
    }
  }
  showSplashScreen() {
    if (this.canShowSplashScreen) {
      this.canShowSplashScreen = false;
      this.setBodyFixed(false);
    } else {
      // this.getSplashTopMargin();
      this.canShowSplashScreen = true;
      this.populateOldSelectedData();
      this.setBodyFixed(true);
      // this.populateDdl();
    }

  }

  /**
      * to make background unaccessible while collapsible shown
      * @param  {boolean} setFixed
      * @returns void
      */
  setBodyFixed(setFixed: boolean, isOutsideClick?: boolean): void {
    // To resolve the screen right shifting, when any popup or country selection opened.
    this._commonService.jumpingScroll(setFixed);
    this._appMessageService.isBodyScrolling = true;
    if (setFixed) {
      this.scrollRetainPos = document.documentElement.scrollTop || document.body.scrollTop;
      document.body.style.position = 'fixed';
    } else {
      document.body.style.position = 'static';
      if (isOutsideClick) {
        this.scrollRetainPos = 0;
      }
      this._commonService.scrollByValue(0, this.scrollRetainPos, 0);
      this._appMessageService.isBodyScrolling = false;
    }
  }

  closeSplashScreen() {
    this.canShowSplashScreen = false;
    this.setBodyFixed(false);
  }

  /**
  * on continue in splash screen to save settings.
  * @returns void
  */

  setCountryLangInfo(language: any, $event: any) {
    const cartSession: Cart = this._cacheService.get(CacheKey.CartSessionInfo);
    $event.stopPropagation(); // stopping document / parent click
    if (environment.betaPortal && !this.browserCountry.titanPlatformEnabled
      || (environment.allCountriesCorporateEnabled && !this.browserCountry.titanPlatformEnabled
        && this.browserCountry.corporatesiteEnabled)) {
      const parentCountry = this.validateParentCountryCodeByCountry(this.browserCountry);
      if (parentCountry) {
        this.getLanguagesForNonTitanEnabledCountry(-1, parentCountry, true, language);
      } else {
        this._cacheService.set(CacheKey.PreviewConfig, this.previewConfig);
        this._cacheService.setCookieValue(CacheKey.languageCode, language.languageCulture);
        this.setLanguageDirectionCookie(language.displayDirection);
        this._cacheService.remove(CacheKey.SiteMaps);
        this._cacheService.setCookieValue(CacheKey.countryCode, this.browserCountry.isocodeThree.toLowerCase());
        window.location.href = decodeURIComponent(encodeURIComponent(window.location.origin + '/' 
          + this.browserCountry.isocodeThree.toLowerCase() + '/' + language.languageCulture.toLowerCase() + '/home'));
      }
      return;
    }
    if (!this.browserCountry.titanPlatformEnabled) {
      this.modalLanguage = language;
      if (this.browserCountry.titanPlatformEnabled && this.initalSettingValues.country.countryId !== this.browserCountry.countryId
        && this.countryLangSettings && cartSession && cartSession.items && cartSession.items.length > 0 && this.isCountryChanged) {
        this.clearCartOnCountryChangeNotification(cartSession);
      } else {
        this.navigateToLegacy(this.browserCountry);
      }
    } else {
      this.modalLanguage = language;
      if (this.browserRegion && this.browserCountry && this.modalLanguage) {
        this.isoCountryCode = (this.browserCountry.isocodeThree).toLowerCase();
        this._cacheService.setCookieValue(CacheKey.languageCode, this.modalLanguage.cultureName || this.modalLanguage.languageCulture);
        this._cacheService.setCookieValue(CacheKey.countryCode, this.isoCountryCode);
        this.setLanguageDirectionCookie(language.displayDirection);
        this._cacheService.remove(CacheKey.PreviewConfig);
        document.getElementsByTagName('body')[0].style.overflow = 'auto';
        this.isoCountryCode = this.browserCountry.name;
        this.selectedLanguage = this.modalLanguage.displayText;
        if (this.initalSettingValues.country.countryId === this.browserCountry.countryId &&
          this.initalSettingValues.language.languageId === this.modalLanguage.languageId && this.countryLangSettings) {
          if (canShowSplashInitally) {
            this.saveChangeSettings();
          } else {
            this.closeSplashScreen();
          }
        } else if (this.initalSettingValues.country.countryId === this.browserCountry.countryId &&
          this.initalSettingValues.language.languageId !== this.modalLanguage.languageId && this.countryLangSettings) {
          this.saveChangeSettings();
        } else {
          this.clearCartOnCountryChangeNotification(cartSession);
        }
      }
    }
  }

  /**
   * Set Selected lanaguage direction
   * @param displayDirection 
   */
  setLanguageDirectionCookie(displayDirection: string) {
    if (displayDirection) {
      this._cacheService.setCookieValue(CacheKey.LanguageDisplayDirection, displayDirection);
    } else {
      this._cacheService.setCookieValue(CacheKey.LanguageDisplayDirection, displayDirection);
    }
  }

  /**
   * @description showing the alert message to Clear the cart on the country change
   * @date 2018-08-13
   * @param {Cart} cartSession
   * @memberof CountryLanguageComponent
   */
  clearCartOnCountryChangeNotification(cartSession: Cart): void {
    if (this.initalSettingValues.country.countryId !== this.browserCountry.countryId && this.countryLangSettings &&
      cartSession && cartSession.items && cartSession.items.length > 0 && this.isCountryChanged) {
      const cookieBannerData: CookieBannerResponse = {
        title: null,
        description: Translations.REFRESH_CART_MESSAGE,
        notificationType: CookieBannerType.CartItemNotification,
        showBanner: true
      };
      this._appMessageService.setCookieBannerData(cookieBannerData);
    } else {
      this.saveChangeSettings();
    }
  }

  saveChangeSettings() {
    const selectedCountLang = {
      countryCode: this.isoCountryCode, languageCode: this.selectedLanguage,
      selectedCountry: this.selectedCountry, selectedLanguageName: this.selectedLanguageName
    };
    this.countryLanguageChange.emit(selectedCountLang);
    const cartSession: Cart = this._cacheService.get(CacheKey.CartSessionInfo);
    const wishListSession = this._cacheService.get(CacheKey.WishListSession);
    if (wishListSession && wishListSession.items && wishListSession.items.length > 0
      && this.countryLangSettings.countryId !== this.browserCountry.countryId) {
      this._cacheService.remove(CacheKey.WishListSession);
    }
    if (this.countryLangSettings.countryId !== this.browserCountry.countryId) {
      this._cacheService.remove(CacheKey.SiteMaps);
    }
    if (cartSession && this.countryLangSettings.countryId !== this.browserCountry.countryId) {
      this.clearCartItems(cartSession);
    } else {
      this.setCountryAndLanguage();
    }

  }

  /**
   * clear cart items when we change country
  * @returns void
  */
  clearCartItems(cartSession: Cart): void {
    if (cartSession) {
      this._cacheService.remove(CacheKey.CartSessionInfo);
      this._cacheService.remove(CacheKey.WishListSession);
      //   this._cacheService.removeCookieValue(CacheKey.CartSessionGuid);
      // if (!this.userInfo) {
      //   this._cacheService.setCookieValue(CacheKey.ClearCart, true);
      // }
      this.setCountryAndLanguage();
    }
  }

  populateDdl() {
    const countLangSett: any = this._cacheService.get(CacheKey.CountryLangSettings);
    this.browserRegion = this.portalCountries.find((item: any) => item.regionId === countLangSett.regionId);
    this.onRegionChange(this.browserRegion.regionId, -1);
    this.browserCountry = this.countries ? this.countries.find((x: any) => x.countryId === countLangSett.countryId) : null;
    this.modalLanguage = this.store.languages.find((item: any) => item.languageId === countLangSett.langId);
    this.initalSettingValues = { country: this.browserCountry, language: this.modalLanguage, region: this.browserRegion };
  }

  populateOldSelectedData() {
    if (this.canShowSplashScreen && this.initalSettingValues) {
      this.browserRegion = this.initalSettingValues.region;
      this.countries = this.browserRegion ? this.portalCountries.filter(item => (item.regionId === this.browserRegion.regionId))
        .map(item => item.countries)[0] : null;
      this.portalImageUrl = this.browserRegion ? this.browserRegion.imageUrl : '';
      this.browserCountry = this.initalSettingValues.country;
      this.modalLanguage = this.initalSettingValues.language;
    }
  }

  getSplashTopMargin() {
    if (document.getElementById('global-banner')) {
      const header = document.getElementById('global-banner');
      // mobile devices and small screens
      if (header.offsetWidth < 768) {
        let ht = 0;
        const appCookiBannerHeight = document.getElementById('app-cookie-banner');
        if (this.countryLangSettings && appCookiBannerHeight) {
          ht = appCookiBannerHeight.offsetHeight;
        } else if (this.countryLangSettings) {
          ht = header.offsetHeight;
        } else {
          ht = 0;
        }
        return ht;
      }
      if ((this.marginFlag && this.countryLangSettings)) {
        if (header.offsetHeight) {
          return header.offsetHeight;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    }
  }

  /**
    * to get configurations
    * @param  {string} country
    */
  getConfigurations(country: string) {
    if (country) {
      // this.isoCountryCode = this._commonService.getISOThreeLetterCountryCode(country);
      const languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
      this._cacheService.setCookieValue(CacheKey.CountryId, this.browserCountry.countryId);
      //this._cacheService.set(CacheKey.CountryId, this.browserCountry.countryId);
      // set the cookie value for hide the initial spashscreen
      this._cacheService.setCookieValue(CacheKey.SplashScreen, 'false');
      if (this._cacheService.get(CacheKey.CountryMetaData) && this._cacheService.get(CacheKey.UserInfo)) {
        this._commonService.updateCountryCodeinCookie();
        const language = this._cacheService.getCookieValue(CacheKey.languageCode);
        const countryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
        window.location.href = decodeURIComponent(encodeURIComponent(environment.baseHref
          + countryCode.toLowerCase() + '/' + language.toLowerCase() + '/home'));
      }
      else {
      window.location.href = decodeURIComponent(encodeURIComponent(environment.baseHref
        + this.isoCountryCode.toLowerCase() + '/' + languageCode.toLowerCase() + '/home'));
      }
      if (!this.countryLangSettings) {
        this.marginFlag = false;
      }
      setTimeout(() => {
        if (this.browserRegion && this.browserCountry && this.modalLanguage) {
          const countLangSett = {
            regionId: this.browserRegion.regionId,
            countryId: this.browserCountry.countryId,
            langId: this.modalLanguage.languageId
          };
          this._cacheService.set(CacheKey.CountryLangSettings, countLangSett);
          this.countryLangSettings = countLangSett;
          this.selectedCountry = this.browserCountry;
          this.selectedLanguageName = this.modalLanguage.displayText;
        }
      }, 0);
    }
  }
  /**
   * To show country selection popup
   * @param  {any} element
   * @param  {boolean} isShow
   */
  showPopup(isShow: boolean) {
    if (isShow) {
      this.isCountryPopupOpen = true;
      //  element.classList.add('scaleup');
    } else {
      this.isCountryPopupOpen = false;
      // element.classList.remove('scaleup');
      this.searchCountry = '';
    }
  }
  /**
   * change country modal popup
   * @param  {any} country
   * @returns void
   */
  countryChangeModal(country: any): void {
    this.isModalShown = true;
    this.countryInfo = country;
  }
  public onHidden(): void {
    this.isModalShown = false;
    this.isShowCountryPopup = false;
  }

  getStoreData() {
    const result = this._configurationService.getStoreData();
    if (result != null) {
      this.store = result;
    }
  }

  /**
* Navigate to Instant Authorization
*/
  instantAuthorizationNavigation(): void {
    const languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
    this.showSplashScreen();
    let redirectUrl = '/' + this.isoCountryCode.toLowerCase() + '/' + languageCode.toLowerCase() + '/account/instantauthorization';
    redirectUrl = decodeURIComponent(encodeURIComponent(environment.accountSiteURL + redirectUrl));
    window.location.href = this._commonService.appendFBOID(redirectUrl);
  }

  /**
* Select Home Country when Country selected is participating country
*/
  getHomeCountryByParticipatingCountry(participatingCountry: Country): Country {
    if (participatingCountry && this.allCountries && this.allCountries.length > 0) {
      const homeCountryCode = participatingCountry.associatedCountryCodeThree;
      if (homeCountryCode) {
        const homeCountry: Country = this.allCountries.find((x: Country) => x.isocodeThree === homeCountryCode);
        return homeCountry;
      }
    }
  }

  ngAfterContentChecked(): void {
    // if (!this.elementHeight) {
    //   const screenWidth = window.innerWidth;
    //   if (screenWidth && screenWidth >= 768) {
    //     this.elementHeight = 100;
    //   } else {
    //     this.elementHeight = 200;
    //   }
    // }
    // this.coutrySplashHeight = this.elementHeight;
  }

  onEscape() {
    console.log('Escape clicked');
    this.canShowSplashScreen = false;
    this.outsideClickCloseSplashScreen(false);
    this.escapeClicked.emit(true);
  }

  selectFirstCountry() {
    setTimeout(() => {
      let inputField: HTMLElement = <HTMLElement>document.querySelectorAll('#countrylnk0')[0];
      inputField && inputField.focus();
    }, 50);
  }

  selectFirstLanguage() {
    console.log('triggering language link');
    setTimeout(() => {
      let inputField: HTMLElement = <HTMLElement>document.querySelectorAll('#languageLnk0')[0];
      inputField && inputField.focus();
    }, 50);
  }

  ngOnDestroy() {
    this.canShowSplashScreen = false;
  }
}
